<div class="flex flex-row items-center justify-around">
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="addBtn"
    title="Add to body"
    (click)="onAddToBody(relatedArticle.value)"
  >
    <i class="icon icon-plus-circle"></i>
  </button>
  <p class="w-10/12 px-2 text-xs">
    {{ relatedArticle.value.title }}
  </p>
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="infoBtn"
    title="info"
    (click)="onInfoClick(relatedArticle.value)"
  >
    <i class="icon icon-info-circle"></i>
  </button>
  <button
    class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
    data-testid="removeBtn"
    title="Remove"
    (click)="onRemove(relatedArticle.value)"
  >
    <i class="icon icon-minus-circle"></i>
  </button>
</div>
